export const V2_INPUT_HEIGHT_PX = 56;
export const V2_INPUT_WIDTH_PX = 312;
export const V2_ICON_MIN_SIZE = 24;
export const V2_BUTTON_SIZES = {
  large: {
    height: 56,
    paddingX: 24,
    paddingY: 16,
    iconSize: 24,
  },
  small: {
    height: 40,
    paddingX: 16,
    paddingY: 8,
    iconSize: 24,
  },
} as const;

export const Spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
} as const;

export const Radius = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
} as const;
